import { Model } from '~contentful/models/model';

export abstract class ActionModel extends Model {
  get parent() {
    return (this.__parent && this.__parent.parent) || this.__parent;
  }

  get forModel() {
    return this.__parent;
  }
}
